<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="昵称：">
                    <el-input size="default" v-model.trim="formInline.nickname" maxlength="60"  clearable placeholder="用户昵称" @change="search" style="width:150px"></el-input>
                </el-form-item>
                <el-form-item label="手机号：">
                    <el-input size="default" v-model.trim="formInline.username" maxlength="60"  clearable placeholder="手机号" @change="search" style="width:150px"></el-input>
                </el-form-item>
                <el-form-item label="账号状态：">
                    <el-select size="default" v-model="formInline.is_active" placeholder="请选择" clearable style="width: 120px" @change="search">
                        <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="注册时间：">
                    <el-date-picker
                            style="width:350px"
                            v-model="timers"
                            type="datetimerange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search" v-show="hasPermission(this.$route.name,'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
                <!-- <el-form-item label=""><el-button  @click="addAdmin" type="primary" icon="Plus" v-show="isShowBtn('userManage','用户管理','Create')">新增</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="exportDataBackend" type="primary">导出</el-button></el-form-item> -->
            </el-form>
        </div>
        <ul class="order-static" ref="orderStatic">
            <li>累计注册用户量：{{orderstatics.totalUsers}}个</li>
        </ul>
        <div class="table">
            <el-table  :height="'calc('+(tableHeight)+'px)'" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <!-- <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column> -->
                <el-table-column width="80" prop="id" label="用户ID"></el-table-column>
                <el-table-column width="80" prop="avatar" label="头像">
                    <template #default="scope">
                        <el-image :preview-src-list="[scope.row.avatar]" :preview-teleported="true" :src="scope.row.avatar ? scope.row.avatar : defaultImg" style="width: 30px;height: 30px" :onerror="defaultImg" ></el-image>
                    </template>
                </el-table-column>
                <el-table-column min-width="110" prop="nickname" label="昵称"></el-table-column>
                <el-table-column min-width="110" prop="username" label="账号"></el-table-column>
                <el-table-column min-width="190" label="摊位会员信息">
                    <template #default="scope">
                       <div v-if="!!scope.row.vip_expire">
                            会员类型：<span>{{scope.row.stallvipinfo}}</span>
                       </div>
                        <div v-if="!!scope.row.vip_expire">
                            到期时间：<span>{{scope.row.vip_expire}}</span>
                        </div>
                        <div v-if="!(!!scope.row.vip_expire)">
                            未开通
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="190" label="店铺会员">
                    <template #default="scope">
                        <div v-if="!!scope.row.shopvipinfo">
                             会员类型：<span>{{scope.row.shopvipinfo.package_name}}</span>
                        </div>
                         <div v-if="!!scope.row.shopvipinfo">
                             到期时间：<span>{{scope.row.shopvipinfo.expire_time}}</span>
                         </div>
                         <div v-if="!(!!scope.row.shopvipinfo)">
                            未开通
                        </div>
                     </template>
                </el-table-column>
                <!-- <el-table-column min-width="100" prop="mobile" label="手机号"></el-table-column> -->
                <el-table-column min-width="100" label="账号状态">
                    <template #default="scope">
                        <!-- <el-tag v-if="scope.row.is_active">正常</el-tag>
                        <el-tag v-else type="danger">禁用</el-tag> -->
                        <el-switch
                            v-model="scope.row.is_active"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changeStatus(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column min-width="180" prop="create_datetime" label="注册时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="180">
                    <template #header>
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>操作</div>
                            <div @click="setFull">
                                <el-tooltip content="全屏" placement="bottom">
                                    <el-icon ><full-screen /></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template #default="scope">
                        <!-- <span class="table-operate-btn" @click="handleEdit(scope.row,'WatchTW')" v-show="hasPermission(this.$route.name,'WatchTW')" v-if="!!scope.row.vip_expire">查看摊位</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'WatchDP')" v-show="hasPermission(this.$route.name,'WatchDP')" v-if="!!scope.row.shopvipinfo">查看店铺</span> -->
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'WatchTW')" v-show="hasPermission(this.$route.name,'WatchTW') && !!scope.row.vip_expire">查看摊位</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'WatchDP')" v-show="hasPermission(this.$route.name,'WatchDP') && !!scope.row.shopvipinfo">查看店铺</span>
                        <!-- <span class="table-operate-btn" @click="handleEdit(scope.row,'edit')" v-show="isShowBtn('userManage','用户管理','Update')">编辑</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'detail')" v-show="isShowBtn('userManage','用户管理','Retrieve')">详情</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'delete')" v-show="isShowBtn('userManage','用户管理','Delete')">删除</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'disable')" v-show="isShowBtn('userManage','用户管理','Update')">
                            <span v-if="scope.row.is_active">禁用</span>
                            <span v-else>启用</span>
                        </span> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <add-user ref="addUserFlag" @refreshData="getData"></add-user>
        <user-detail ref="userDetailFlag"></user-detail>
        <AddModuleShop ref="addModuleShopFlag" v-if="isDetailDialogShow" @closed="isDetailDialogShow=false"></AddModuleShop>
        <AddModuleStall ref="addModuleStallFlag" v-if="isDetailStallDialogShow" @closed="isDetailStallDialogShow=false"></AddModuleStall>
    </div>
</template>
<script>
    import addUser from "./components/addUser";
    import Pagination from "@/components/Pagination";
    import {dateFormats,getTableHeight} from "@/utils/util";
    import {UsersUsers,UsersUsersDelete,UsersUsersdisableEdit,UsersUsersExportexecl} from '@/api/api'
    import UserDetail from "./components/userDetail";
    import { lyMixins } from "@/mixins/mixins"
    import AddModuleShop from "./components/addModuleShop";
    import AddModuleStall from "./components/addModuleStall";
    export default {
        mixins: [lyMixins],
        components:{
            UserDetail,
            Pagination,
            addUser,
            AddModuleShop,
            AddModuleStall
        },
        name:'userManage',
        data() {
            return {
                isFull:false,
                tableHeight:500,
                loadingPage:false,
                formInline:{
                    page: 1,
                    limit: 10,
                },
                defaultImg:require('../../assets/img/avatar.jpg'),
                orderstatics:{
                    totalUsers: 0,
                },
                pageparm: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                statusList:[
                    {id:1,name:'正常'},
                    {id:0,name:'禁用'}
                ],
                identityList:[
                    {id:0,name:'普通用户'},
                    {id:1,name:'会员'},
                ],
                timers:[],
                tableData:[],
                isDetailDialogShow:false,
                isDetailStallDialogShow:false,
            }
        },

        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            setFull(){
                this.isFull=!this.isFull
                window.dispatchEvent(new Event('resize'))
            },
            changeStatus(row) {
                let vm = this
                let flat = row.is_active
                row.is_active = !row.is_active
                let temp_is_allow = 1
                vm.$confirm('确定修改状态吗？','提醒',{
                    closeOnClickModal:false,
                    type: "warning"
                }).then(res=>{
                    flat ? row.is_active = true : row.is_active = false
                    if(row.is_active){
                        temp_is_allow = 1
                    }else{
                        temp_is_allow = 0
                    }
                    UsersUsersdisableEdit({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.getData()
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }).catch(()=>{

                })
            },
            addAdmin() {
                this.$refs.addUserFlag.addUserFn(null,'新增')
            },
            handleEdit(row,flag) {
                let vm = this
                if(flag=='edit') {
                    this.$refs.addUserFlag.addUserFn(row,'编辑')
                }
                else if(flag=='WatchTW') {
                    this.isDetailStallDialogShow = true
                    this.$nextTick(()=>{
                        vm.$refs.addModuleStallFlag.addModuleFn(row,'查看房源')
                    })
                }
                else if(flag=='WatchDP') {
                    this.isDetailDialogShow = true
                    this.$nextTick(()=>{
                        vm.$refs.addModuleShopFlag.addModuleFn(row,'查看店铺')
                    })
                }
                else if(flag=='disable'){
                    UsersUsersdisableEdit({id:row.id}).then(res=>{
                            if(res.code == 2000) {
                                vm.$message.success(res.msg)
                                vm.getData()
                            } else {
                                vm.$message.warning(res.msg)
                            }
                        })
                }
                else if(flag=='delete') {
                    let vm = this
                    vm.$confirm('您确定要删除选中的数据吗？',{
                        closeOnClickModal:false
                    }).then(res=>{
                        UsersUsersDelete({id:row.id}).then(res=>{
                            if(res.code == 2000) {
                                vm.$message.success(res.msg)
                                vm.getData()
                            } else {
                                vm.$message.warning(res.msg)
                            }
                        })
                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                    this.formInline = {
                        page:1,
                        limit: 10
                    }
                    this.pageparm={
                        page: 1,
                        limit: 10,
                        total: 0
                    }
                    this.getData()
                }
            },
            /**
             * 从URL里下载文件
            */
            // 下载文件
            downloadFileURL(url) {
                var iframe =document.createElement("iframe")
                iframe.style.display ="none";
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            exportDataBackend() {
                var params = {
                    page: 1,
                    limit: 9999,
                }
                UsersUsersExportexecl(params).then(res => {
                     if(res.code ==2000) {
                         this.downloadFileURL(res.data.data)
                         //this.$message.warning(res.data.data)
                     }
                 })
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 10
                this.getData()
            },
            //获取列表
            async getData() {
                this.loadingPage = true
                UsersUsers(this.formInline).then(res => {
                     this.loadingPage = false
                     if(res.code ==2000) {
                         this.tableData = res.data.data
                         this.pageparm.page = res.data.page;
                         this.pageparm.limit = res.data.limit;
                         this.pageparm.total = res.data.total;
                         this.orderstatics.totalUsers = res.data.total
                     }
                 })
            },

            timeChange(val){
                if (val) {
                    this.formInline.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
                    this.formInline.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
                } else {
                    this.formInline.beginAt = null
                    this.formInline.endAt = null
                }
                this.search()
            },

        },
        created() {
            this.getData()
        },
    }
</script>
<style lang="scss">
    .order-static{
        display: flex;
        font-size: 14px;
        background: var(--l-order-statics);
        padding: 10px;
        li{
            margin-right: 30px;

        }
    }
</style>
